/**
 * Android / external boarding URL.
 * Example:
 * /passenger-boarding?ptfrm=android&tkn=&intTripID=191557&dtJDate=2026-10-19&intCompanyID=1&userId=12345
 */
export function parseBoardingContextFromUrlParams(searchParams) {
  const params = searchParams?.toString?.()
    ? searchParams
    : new URLSearchParams(window.location.search);
  const tripId = params.get("intTripID") ?? params.get("TripID");
  const journeyDate = params.get("dtJDate") ?? params.get("JourneyDate");
  const companyId =
    params.get("intCompanyID") ??
    params.get("CompanyId") ??
    params.get("iCompanyid");
  const userId =
    params.get("userId") ??
    params.get("intUserId") ??
    params.get("UserID");

  const missing = [];
  if (!tripId) missing.push("intTripID");
  if (!journeyDate) missing.push("dtJDate");
  if (!companyId) missing.push("intCompanyID");
  if (!userId) missing.push("userId");

  if (missing.length) {
    return { isValid: false, missing };
  }

  return { isValid: true, tripId, journeyDate, companyId, userId };
}
